import React from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import AttendanceDashboard from './component/AttendanceDashboard'
const Attendance = () => {
    return (
       
         <AttendanceDashboard />
       
    )
}

export default Attendance
